// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__8t-cC","label":"Labeled_label__3wBbO","divider":"Labeled_divider__3kgmd"};